import React from 'react';
import {
  ActivityIndicator,
  Modal,
  Platform,
  StyleSheet,
  Text,
  View,
} from 'react-native';

import { colors, spacing } from '../../theme';

export function FormSavingOverlay({
  visible,
  message = 'Saving request…',
}: {
  visible: boolean;
  message?: string;
}): React.JSX.Element | null {
  if (!visible) {
    return null;
  }

  const card = (
    <View style={styles.card} accessibilityRole="progressbar">
      <ActivityIndicator size="large" color={colors.primary} />
      <Text style={styles.label}>{message}</Text>
    </View>
  );

  if (Platform.OS === 'web') {
    return (
      <View
        style={styles.webBackdrop}
        testID="form-saving-overlay"
        accessibilityViewIsModal
        importantForAccessibility="yes"
      >
        {card}
      </View>
    );
  }

  return (
    <Modal
      visible
      transparent
      animationType="fade"
      statusBarTranslucent
      testID="native-form-saving-overlay"
      accessibilityViewIsModal
      onRequestClose={() => undefined}
    >
      <View style={styles.backdrop}>{card}</View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  webBackdrop: {
    ...Platform.select({
      web: {
        position: 'fixed' as const,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999,
      },
      default: {},
    }),
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
  },
  backdrop: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
  },
  card: {
    minWidth: 190,
    alignItems: 'center',
    gap: spacing.md,
    paddingHorizontal: spacing.xl,
    paddingVertical: spacing.lg,
    borderRadius: 12,
    backgroundColor: colors.backgroundPrimary,
  },
  label: {
    color: colors.textPrimary,
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
});
